import React, { useEffect, useState } from 'react';
import { getAzureProviders, getTerraformSchema } from '../api.js';

export default function TestAPI() {
  const [providers, setProviders] = useState([]);
  const [schema, setSchema] = useState(null);

  useEffect(() => {
    // Charger la liste des providers Azure
    getAzureProviders()
      .then(res => setProviders(res.data))
      .catch(err => console.error('Erreur Azure Providers:', err));

    // Charger le schéma Terraform
    getTerraformSchema()
      .then(res => setSchema(res.data))
      .catch(err => console.error('Erreur Terraform Schema:', err));
  }, []);

  return (
    <div>
      <h2>Test API</h2>
      <h3>Azure Providers:</h3>
      <pre>{JSON.stringify(providers, null, 2)}</pre>
      <h3>Terraform Schema:</h3>
      <pre>{JSON.stringify(schema, null, 2)}</pre>
    </div>
  );
}
